<template lang="pug">
.shadow.bg-white.py-3.rounded
  img(:src="icon")
  p {{ title }}
</template>

<script>
export default {
  name: "Benefit",
  props: {
    title: String,
    icon: String,
  },
};
</script>

<style scoped lang="scss">
.benefits {
  img {
    width: 50px;
  }

  p {
    font-size: 0.875rem;
    margin-bottom: 0;
  }
}
</style>
